import * as types from '../mutation-types'
import { API } from '../../api';
import { REPORT_DATA_MANAGER } from '../../data';
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        curYear: 2025, //当前年份,
        curYearReportData: {},
        curYearReportAIData: {},
        curYearReportTalentData: {},
        curYearReportFiveData: {},
        curYearReportMonthShowAll: false,
        curYearReportMonthDataList: [],
        curYearReportMonthTotalDataList: [],
        curYearReportDayunDataList: [],
        detailInfo: null,
        characterAIData: {},
        characterDesData: {},
        characterUnlockTime: 0,
        reportYearList: [],
        reportYearProduct: {}
    },
    mutations: {
        
    },
    actions: {
        initYearCharacter({ state }, params) {
            if(!params || !params.detailInfo) { return; }
            console.log('initYearCharacter----', params.detailInfo)
            state.detailInfo = params.detailInfo;
            API.getYearCharacter({
                hid: state.detailInfo.id
            }, (data)=> {
                console.log('获取性格数据成功-----', data)
                state.characterAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.ai);
                state.characterDesData = data.des;
                state.characterUnlockTime = data.f_unlock_time;
                if(data.f_unlock_time == 0) {
                    if(params && params.characterCb && typeof(params.characterCb) == 'function') {
                        params.characterCb();
                    }
                }else {                    
                    if(params && params.reportCb && typeof(params.reportCb) == 'function') {
                        params.reportCb();
                    }
                }
            })
        },
        unlockYearCharacter({ state }, params) {
            if(!state.detailInfo) { return; }
            API.setCharacterUnlock({
                hid: state.detailInfo.id
            }, (data)=> {
                console.log('免费解锁性格数据成功-----', data);
                // 手动更新一下characterUnlockTime状态
                state.characterUnlockTime = 1;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })

        },
        getYearReportInfo({ state, dispatch }, params) {
            if(!state.detailInfo) { return; }
            API.getYearInfo({
                hid: state.detailInfo.id
            }, (data)=> {
                console.log('获取年运报告成功-----', data);
                state.reportYearList = data.list;
                state.reportYearProduct = data.product;
                let curData = state.reportYearList.find(el => {return el.isNow});
                state.curYear = params && params.first && curData ? curData.year : state.curYear;
                dispatch('updateCurYearReportData', {year: state.curYear});
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        updateCurYearReportData({ state, dispatch }, params) {
            let haveYear = state.reportYearList.find(el => {return el.year == params.year});
            console.log('updateCurYearReportData-----', params.year, haveYear);
            if(!haveYear) {return;}
            state.curYear = params.year;
            let reportData = state.reportYearList.find(el => {return el.year == params.year});
            state.curYearReportData = Object.assign({}, reportData);
            dispatch('getCurYearReportAIData'); //获取UI数据
        },
        getCurYearReportAIData({ state, dispatch }) {
            let rData = Object.assign({}, state.curYearReportData);
            state.curYearReportAIData = rData.ai ? REPORT_DATA_MANAGER.getYearReportAIDataByData(rData.ai) : {};
            if(rData.ai && rData.ai.talent) {
                let talentData = REPORT_DATA_MANAGER.getTalentDataByData(rData.ai.talent);
                state.curYearReportTalentData = Object.assign(talentData, rData.ai.talent);
                state.curYearReportTalentData = Object.assign({needpay: 0}, state.curYearReportTalentData);
            };
            if(state.curYearReportAIData.five) {
                dispatch('updateCurYearReportFiveData', {year: state.curYear});
            }
            let monthDataList = REPORT_DATA_MANAGER.getYearReportMonthDataByData(state.curYearReportAIData.month);
            state.curYearReportMonthTotalDataList = [].concat(monthDataList);
            if(state.curYearReportAIData.month) {
                dispatch('updateCurYearReportMonthDataList', {index: state.curYearReportAIData.month.curIndex});
            }
            let dayunDataList = REPORT_DATA_MANAGER.getYearReportDayunDataByData(state.curYearReportAIData.daYun);
            state.curYearReportDayunDataList = [].concat(dayunDataList);
            // console.log('getCurYearReportAIData-----', state.curYearReportAIData, state.curYearReportTalentData, state.curYearReportMonthTotalDataList, state.curYearReportDayunDataList);
        },
        updateCurYearReportFiveData({ state }, params) {
            if(!state.curYearReportAIData.five) { return; }
            state.curYearReportFiveData = REPORT_DATA_MANAGER.getYearReportFiveDataByYear(params.year, state.curYearReportAIData.five);
        },
        updateCurYearReportMonthDataStatus({ state }) {
            state.curYearReportMonthShowAll = !state.curYearReportMonthShowAll;
            if(state.curYearReportMonthShowAll) {
                state.curYearReportMonthDataList = [].concat(state.curYearReportMonthTotalDataList)
            }else {
                state.curYearReportMonthDataList = [].concat(state.curYearReportMonthTotalDataList[0])
            }
        },
        updateCurYearReportMonthDataList({ state }, params) {
            if(state.curYearReportMonthTotalDataList.length == 0) {return; }
            let index = params.index;
                index = index < 0 ? 0 : index;
            state.curYearReportMonthShowAll = false;
            state.curYearReportMonthDataList = [].concat(state.curYearReportMonthTotalDataList[index]);
        },
        freeUnlockYearReport({ state, dispatch }, params) {
            API.freeUnlockYear({
                id: params.id
            }, (data)=> {
                console.log('免费解锁年运成功:::::::', data)
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, ()=> {
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        resetYearCharacterData({ state }) {
            state.characterAIData = {};
            state.characterDesData = {};
            state.characterUnlockTime = 0;
        },
        resetYearReportData({ state }) {
            state.curYear = 2025;
            state.curYearReportData =  {};
            state.curYearReportAIData =  {};
            state.curYearReportTalentData =  {};
            state.curYearReportFiveData =  {};
            state.curYearReportMonthShowAll =  false;
            state.curYearReportMonthDataList =  [];
            state.curYearReportMonthTotalDataList =  [];
            state.curYearReportDayunDataList =  [];
        },
        resetYearData({ state }) {
            state.reportYearList =  [];
            state.reportYearProduct =  [];
            state.curYearReportData =  {};
            state.curYearReportAIData =  {};
            state.curYearReportTalentData =  {};
            state.curYearReportFiveData =  {};
            state.curYearReportMonthShowAll =  false;
            state.curYearReportMonthDataList =  [];
            state.curYearReportMonthTotalDataList =  [];
            state.curYearReportDayunDataList =  [];
        }
    }
}
